import React, { Component } from 'react';
import { Form } from 'react-bootstrap';

class QuizinatorInfo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ans: null,
            cont: false
        };

        this.handleClick = this.handleClick.bind(this);
    }
    render() {
        let quiz = this.props.quiz,
            question = this.props.quiz.questions[this.props.currentQuestionIndex],
            htmlQuestion = function () {
                return { __html: question.html };
            };

        return (
            <section className={'quizSection' + (this.props.buttonsDisabled ? ' transitionOut' : '')}>
                <div className="questionNumber">Question {this.props.currentQuestionIndex + 1} / {quiz.questions.length}</div>
                <div className="question">
                    <div dangerouslySetInnerHTML={htmlQuestion()} />
                </div>
                <div className="answers">
                    <button onClick={this.handleClick}>Next</button>
                </div>
            </section>
        );
    }

    handleClick(event) {
        let { ans } = this.state;
        let answer = { value: 0 },
            target = event.currentTarget;

        this.props.submitAnswer(answer);

        target.classList.add('clicked');

        let that = this;
        window.setTimeout(function () {
            target.classList.remove('clicked', 'correct', 'incorrect');
            that.setState({cont: false, ans: null});
        }, this.props.transitionDelay);
    }
}

export default QuizinatorInfo;